export default __webpack_public_path__ + "images/938861a9b1510bc79079c494b7f154cd-plant.svg";